import useSwr from 'swr';
import ActivitiesAuthRoleAuth, {
  ActivitiesAuthRoleAuthRes,
} from '@quickService/ActivitiesAuthRoleAuth';

/**
 * 查询用户角色及权限
 * @param hostId 主办方id
 * @returns 角色及权限
 */
const useRoleAuth = (hostId: string) => {
  const { data } = useSwr(
    {
      url: '/v2/activities/auth/role-auth',
      params: {
        host_id: hostId,
      },
    },
    (reqData) => {
      const { params } = reqData;
      if (params.host_id === '') return Promise.reject('hostId不能为空');
      return ActivitiesAuthRoleAuth(params).then((res: ActivitiesAuthRoleAuthRes) => {
        if (res.code === 0) {
          return res.data;
        }
        return Promise.reject(res?.msg || '');
      });
    },
    {
      revalidateOnFocus: false,
    },
  );

  const noAdmin = data?.host_corp_version === 1 && Number(data?.host_corp_role_id) !== 1; // 企业版并且不是超管
  const noCreate = data?.host_corp_version === 2 && data?.org_role_id !== 1; // 个人版并且不是创建者
  const noPayPermission = noAdmin || noCreate; // 无权限付款
  const admin = data?.host_corp_version === 1 && Number(data?.host_corp_role_id) === 1; // 企业版-超管
  const create = data?.host_corp_version === 2 && data?.org_role_id === 1; // 个人版-创建者

  return {
    authData: {
      ...data,
      noAdmin,
      noCreate,
      admin,
      create,
      noPayPermission,
    },
  };
};

export default useRoleAuth;
